import React, {useEffect, useState} from 'react';
import "./boath.scss";

const Nex = ({booking}) => {
	
    return (
        <div className='boath'>
			<div className='boath__level'>
				<div className="boath__image"><img src={`${window['siteUrl']}/images/boahts/nex-upper.jpg`} alt='nex-upper'/></div>
				<div className='boath__content'>
					nex-upper
				</div>
			</div>
			<div className='boath__level'>
				<div className="boath__image"><img src={`${window['siteUrl']}/images/boahts/nex-lower.jpg`} alt='nex-lower'/></div>
				<div className='boath__content'>
					nex-lower.gif
				</div>
			</div>
        </div>
    );
};

export default Nex;
